module.exports = __webpack_public_path__ + "static/cube23-85c0f791e01a0e4cad4d1f7dd51d7676.svg";